import type {
  MessageDto,
  MessageUnsupportedPresentationDto,
  WhatsAppUnsupportedKind,
} from "@multi-chat/shared";

type Translate = (key: string) => string;

export function unsupportedMessageLabel(
  kind: WhatsAppUnsupportedKind | undefined,
  t: Translate,
  presentation?: MessageUnsupportedPresentationDto,
): string {
  if (presentation?.scope === "instagram") {
    switch (presentation.instagramKind) {
      case "sticker":
        return t("inbox.unsupported.instagramSticker");
      case "location":
        return t("inbox.unsupported.instagramLocation");
      case "content":
      default:
        return t("inbox.unsupported.instagramUnknown");
    }
  }

  if (presentation?.scope === "generic") {
    return t("inbox.unsupported.genericUnknown");
  }

  const resolved: WhatsAppUnsupportedKind = kind ?? "unknown";
  switch (resolved) {
    case "poll_creation":
      return t("inbox.unsupported.pollCreation");
    case "poll_update":
      return t("inbox.unsupported.pollUpdate");
    case "gif":
      return t("inbox.unsupported.gif");
    case "order":
      return t("inbox.unsupported.order");
    case "unknown":
      return t("inbox.unsupported.unknown");
    default: {
      const _exhaustive: never = resolved;
      return _exhaustive;
    }
  }
}

export function unsupportedLabelFromMessage(message: MessageDto, t: Translate): string | null {
  if (message.unsupportedPresentation) {
    return unsupportedMessageLabel(
      message.unsupportedPresentation.kind,
      t,
      message.unsupportedPresentation,
    );
  }
  return null;
}

export function unsupportedKindFromPresentation(
  presentation: MessageUnsupportedPresentationDto | undefined,
): WhatsAppUnsupportedKind | undefined {
  return presentation?.kind;
}
